
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import UpdateBackOrderStatu from '@/store/entities/back-order-update-statu'
    import UpdateOderStatu from './update-mainlandorder-statu.vue'
    import Weight from './weight-input.vue'
    import EditPackedStastus from './order-packed.vue'
    import moment from 'moment'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import AddShipment from './order-addshipment.vue'
    import EditShipment from './order-editshipment.vue'
    import MultiWeight from './multi-weight.vue'
    import Preview from 'vue-photo-preview'
    import ResultModel from '@/store/entities/nationalLogisticsInfo'
    import 'vue-photo-preview/dist/skin.css'
    import { getLodop,demoDownloadPDF } from '@/common/js/LodopFuncs'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)


    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        packedBeginTime?: Date;
        packedEndTime?: Date;
        beginWeighingtTime?: Date;
        endWeighingTime?: Date;
        BeginTime?: Date;
        site?: number;
        EndTime?: Date;
        OrderType?: number;
        UserCode?: string;
        PlatformType?: number
        manlandPackageName: string;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.OrderType = 1;
            //this.PlatformType = 0;
            this.site = null;
        }
    }

    @Component({
        name: "backmainlandOrderList",
        components: { UpdateOderStatu, EditPackedStastus, AddShipment, Weight, EditShipment, MultiWeight }
    })
    export default class MainLandOrders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        packedTime: Date[] = [];
        weighingTime: Date[] = [];
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        Model: ResultModel = null;
        spinShow: boolean = false;
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        Dispaly: string = "";
        // 新增属性 - 用于打包逻辑
        logisticsList: string[] = [];
        orderNumberList: string[] = [];

        CList: Array<any> = [];
        automaticJump: boolean = true;
        
             isLoadPrintList: boolean = false;
        updateOderStatuShow = false;
        needCert: boolean = false;
        editModalShow: boolean = false;
        editShipmentModalShow: boolean = false;
        AddModalShow: boolean = false;
        weightShow: boolean= false;
        async searchPage() {
            this.$store.state.backmainlandorder.currentPage = 1;
            this.getpage();
        }
        get list() {
            return this.$store.state.backmainlandorder.list;
        };
        get loading() {
            return this.$store.state.backmainlandorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backmainlandorder/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        @Watch('$route.params.inputNativeShipment')
        inputNativeShipmentChange() {
            var s = '';
            if (this.$route.params.inputNativeShipment) {
                this.pagerequest = new PageOrderRequest();
                this.pagerequest.SearchInfo = this.$route.params.inputNativeShipment;
                this.$store.state.backmainlandorder.currentPage = 1;
                this.getpage();
            }

        }

        clearPageListChild() {
            var PagSizeList = document.getElementById('SelectPrintPage');
            while (PagSizeList.childNodes.length > 0) {
                var children = PagSizeList.childNodes;
                for (var i = 0; i < children.length; i++) {
                    PagSizeList.removeChild(children[i]);
                };
            };
        }

        processPrintList(json) {
            var select = document.getElementById('SelectPrint');
            // 清空现有选项
            select.innerHTML = '';

            // 添加打印机选项
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                select.appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return false;
        }



        async pdfLinkToBase64(url) {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const arrayBuffer = await response.arrayBuffer();
                const base64String = this.arrayBufferToBase64(arrayBuffer);
                return base64String;
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error;
            }
        }

        arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }

        // 单个订单称重 - 调用获取详情
        async singleWeighing(data: any) {
            if (!data.logistics || data.logistics.length == 0) {
                this.$Message.error('该订单没有快递信息');
                return;
            }
            // 先关闭模态框（确保状态重置）
            this.weightShow = false;

            // 等待 DOM 更新
            await this.$nextTick();

            this.$store.state.backmainlandorder.orderWeighingInfo = null;

            // 从后台获取订单称重详情
            var result = await this.$store.dispatch({
                type: 'backmainlandorder/getOrderWeighingInfo',
                data: { orderId: data.id }
            });

            if (result) {
                // 存储到store
                this.$store.state.backmainlandorder.orderWeighingInfo = result;
                this.$store.state.backmainlandorder.automaticJump = this.automaticJump;
                
                this.weightShow = true;
            }
        }

        // 打开称重模态框
        //openWeightModal(data: any) {
        //    this.$store.state.backmainlandorder.id = data.id;
        //    this.$store.state.backmainlandorder.orderNumber = data.orderNumber;
        //    this.$store.state.backmainlandorder.BaseSkuNums = data.baseSkuNums || data.orderProductInfoList.length;
        //    this.$store.state.backmainlandorder.cargoCategory = data.cargoCategory;
        //    this.$store.state.backmainlandorder.currentLogisticsList = data.logistics;
        //    this.weightShow = true;
        //}

        async printPdf(data) {
            if (!this.isLoadPrintList) {
                var printWorld = new GetPrintWorld();
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;
                json.defaultprn = true;
                printWorld.CallbackOnPrinterList(this.processPrintList);
                if (!printWorld.Act(json)) {
                    alert(printWorld.GetLastError());
                }
                return;
            }

            var pdfData = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                url: '',
            };
            this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);

            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }

            if (pdfData.url && pdfData.url.length > 0) {
                var printWorld = new GetPrintWorld();
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };

                // 获取PDF的Base64数据
                var baseData = await this.pdfLinkToBase64(pdfData.url);

                jsons.action = "printfile";
                jsons.format = "file_base64";
                jsons.content = "data:application/pdf;base64," + baseData;
                jsons.paperlength = 15;
                jsons.paperwidth = 10;

                // 判断是否需要证书（上个页面有这个逻辑）
                if (this.needCert) {
                    jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                }

                jsons.printer = printSelect.value;
                printWorld.Act(jsons);
            }
        }
        //changePrint() {
        //    var printSelect: any = document.querySelector('#SelectPrint');
        //    if (printSelect.value) {
        //        var LODOP = getLodop();
        //        this.clearPageListChild();
        //        var strPageSizeList = LODOP.GET_PAGESIZES_LIST(printSelect.value, "\n");
        //        var Options = new Array();
        //        Options = strPageSizeList.split("\n");
        //        for (var i in Options) {
        //            var option = document.createElement('option');
        //            option.innerHTML = Options[i];
        //            option.value = Options[i];
        //            document.getElementById('SelectPrintPage').appendChild(option);
        //        }
        //    }
        //}
        //GetPrint() {
        //    var LODOP = getLodop();
        //    this.isLoadPrintList = true;
        //    var printSelect: any = document.querySelector('#SelectPrint');
        //    LODOP.Create_Printer_List(printSelect);
        //    this.$Message.success("已加载打印机，请选择指定打印机");

        //}

        //printPdf(data) {
        //    var pdfData = {
        //        pdfGuid: data.pdfGuid,
        //        userId: data.userId,
        //        orderNumber: data.orderNumber,
        //        url: '',
        //    };
        //    this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);
        //    if (pdfData.url && pdfData.url.length > 0) {
        //        var LODOP = getLodop();
        //        if (!this.isLoadPrintList) {
        //            LODOP.Create_Printer_List(document.getElementById('SelectPrint'));
        //            this.$Message.success("已加载打印机，请选择指定打印机");
        //            this.isLoadPrintList = true;
        //            return;
        //        }
        //        var printSelect: any = document.querySelector('#SelectPrint');
        //        if (!printSelect.value) {
        //            this.$Message.success("请选择指定打印机");
        //            return;
        //        }
        //        LODOP.SET_PRINTER_INDEX(printSelect);
        //        LODOP.PRINT_INIT("订单" + data.orderNumber + "打印");
        //        if (pdfData.url.indexOf('https://') != -1) {
        //            var base64 = demoDownloadPDF(pdfData.url);
        //            LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", base64);
        //        } else {
        //            LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", pdfData.url);
        //        }
        //        var pageSelect: any = document.querySelector("#SelectPrintPage");
        //        if (pageSelect.value) {
        //            LODOP.SET_PRINT_PAGESIZE(0, 0, 0, pageSelect.value);
        //        }
        //        LODOP.PRINT();
        //    }
        //}

        async exportexpress() {
            await this.$store.dispatch({
                type: 'backmainlandorder/impotExcel',
                data: this.pagerequest
            })
        }
        async handleRowClick(val: any) {
            var _this = this;
            if (val) {
                this.spinShow = true;
                this.Model = await this.$store.dispatch({
                    type: 'backmainlandorder/getResult',
                    data: { number: val }
                }).finally(() => {
                    //    setTimeout(() => {
                    //    this.spinShow = false;
                    //}, 1000);
                    this.spinShow = false;
                });
                var a = this.Model;
                if (this.Model == null) {
                    this.$Modal.info({
                        title: "提示", content: "没有跟踪信息！", onOk: async () => {
                        }
                    });
                }

                else {
                    if (this.Model.itemInfo != null) {
                        var html = "";
                        var tr = "";
                        var table = "<table style='border:1px solid #0094ff;border-collapse:collapse; cellpadding:2;cellspacing:0;'><tr><td style='border:1px solid #0094ff;'>日期时间</td><td style='border:1px solid #0094ff;'>服务地点</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;详细内容</td></tr>";
                        this.Model.itemInfo.forEach(function (item, index) {
                            tr += "<tr><td style='border:1px solid #0094ff;'>" + item.dateTime + "&#12288;&#12288;</td><td style='border:1px solid #0094ff;'>" + item.serviceSite + "</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;" + item.content + "</td></tr>";
                        })
                        var endtable = "</table>";
                        html = table + tr + endtable;
                        this.$Modal.info({
                            title: "提示", width: 800, content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status + "<br /><br />" + html, onOk: async () => {
                            }
                        });
                    }
                    else {
                        this.$Modal.info({
                            title: "提示", content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status, onOk: async () => {
                            }
                        });
                    }

                }



            };


        }

        pagesizeChange(pagesize: number) {
            this.$store.commit('backmainlandorder/setPageSize', pagesize);
            this.getpage();
        }
        async weighing() {
            this.updatePackageStatus(3);
        }
        async cancelpacked() {
            this.updatePackageStatus(8);
        }
        async packed() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.$store.state.backmainlandorder.ids = ids;
            this.$store.state.backorder.ordertype = 1;
            // this.updatePackageStatus(2);
            this.editModalShow = true;
        }
        async pendingWarehouse() {
            this.updatePackageStatus(6);
        }
        async arriveWarehouse() {

            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
                if (i + 1 < selection.length) {
                    if (selection[i].cargoCategory != selection[i + 1].cargoCategory) {
                        this.$Message.error("选中的数据中货物类别不一致！");
                        return;
                    }
                }
            }
            
            this.$store.state.backmainlandorder.ids = ids;
            this.$store.state.backorder.ordertype = 1;
            this.$store.state.backmainlandorder.cargoCategory = selection[0].cargoCategory;
            // this.updatePackageStatus(2);
            this.AddModalShow = true;
        }
        async updatePackageStatus(statu: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backmainlandorder/updatePackageStatus',
                        data: { ids: ids, PackageStatus: statu, orderType: this.pagerequest.OrderType }
                    });
                    this.getpage();

                }
            });
        }

        //@Watch('$store.state.backmainlandorder.isPacked')
        //isPackedChange() {
        //    if (this.$store.state.backmainlandorder.isPacked) {
        //        this.$router.push({ name: 'backmainlandOrderList' });
        //    }


        //}
        async getpage() {
            //this.$store.state.backmainlandorder.isPacked = true;
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            if (this.packedTime.length > 0) {
                this.pagerequest.packedBeginTime = this.packedTime[0];
            } else {
                this.pagerequest.packedBeginTime = null;
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.packedEndTime = this.packedTime[1];
            } else {
                this.pagerequest.packedEndTime = null;
            }
            if (this.weighingTime.length > 0) {
                this.pagerequest.beginWeighingtTime = this.weighingTime[0];
            } else {
                this.pagerequest.beginWeighingtTime = null;
            }
            if (this.weighingTime.length > 1) {
                this.pagerequest.endWeighingTime = this.weighingTime[1];
            } else {
                this.pagerequest.endWeighingTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            await this.$store.dispatch({
                type: 'backmainlandorder/getAll',
                data: this.pagerequest
            });
        }

        get pageSize() {
            return this.$store.state.backmainlandorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backmainlandorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backmainlandorder.currentPage;
        }
        async Newpacked(data: any) {
            // 重置临时数组
            this.logisticsList = [];
            this.orderNumberList = [];

            // 检查物流单关联多个订单
            for (var j = 0; j < data.logistics.length; j++) {
                if (data.logistics[j].orderCount > 1) {
                    this.logisticsList.push(data.logistics[j].shipment);
                }
            }

            // 检查订单状态
            if (data.productOrderStatus !== null && data.productOrderStatus !== undefined) {
                var statuName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                if (statuName != "待发货") {
                    this.orderNumberList.push(data.orderNumber);
                }
            }

            // 收集异常订单
            var abnormalOrderList: any[] = [];
            if (data.abnormalUserId) {
                abnormalOrderList.push({ orderNumber: data.orderNumber, abnormalUserId: data.abnormalUserId });
            }

            var ids = [data.id];
            var site = data.site;

            // 保存基础SKU数量到store
            this.$store.state.backmainlandorder.BaseSkuNums = data.orderProductInfoList.length;

            // 判断是否需要弹出确认框
            if (this.logisticsList.length > 0) {
                var _this = this;
                _this.$Modal.confirm({
                    title: "是否打包",
                    content: "快递单号为【" + this.logisticsList + "】关联多个订单，是否继续标为已打包？",
                    width: 800,
                    onOk: async () => {
                        this.logisticsList = [];
                        setTimeout(() => {
                            _this.OrderNumberPrompt(ids, abnormalOrderList, site);
                        }, 500);
                    },
                    onCancel: () => {
                        this.logisticsList = [];
                    }
                });
            }
            else {
                this.OrderNumberPrompt(ids, abnormalOrderList, site);
            }
        }

        OrderNumberPrompt(ids: any[], abnormalOrderList: any[], site: any) {
            var _this = this;
            if (_this.orderNumberList.length > 0) {
                _this.$Modal.confirm({
                    title: "是否打包",
                    content: "订单编号为【" + _this.orderNumberList + "】,产品订单状态不为【待发货】状态，是否继续标为已打包？",
                    width: 800,
                    onOk: () => {
                        _this.orderNumberList = [];
                        _this.ShowPacked(ids, abnormalOrderList, site);
                    },
                    onCancel: () => {
                        _this.orderNumberList = [];
                    }
                });
            }
            else {
                _this.ShowPacked(ids, abnormalOrderList, site);
            }
        }

        async ShowPacked(ids: any[], abnormalOrderList: any[], site: any[]) {
            // 设置打包所需的数据到store
            this.$store.state.backmainlandorder.ids = ids;
            this.$store.state.backmainlandorder.abnormalOrderList = abnormalOrderList;
            this.$store.state.backmainlandorder.automaticJump = this.automaticJump;
            this.$store.state.backmainlandorder.site = site;
            this.$store.state.backmainlandorder.ordertype = 1; // 本土订单类型

            // 使用专门的打包模态框
            this.editModalShow = true;
        }

        getImageUrl(guid: string) {
            if (!guid) return '';
            var data = { imageGuid: guid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            return data.url;
        }

        async operationData(name: any, data: any) {
            //if (name == '查看Pdf') {
            //    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
            //    if (packageStatus != "已收货") {
            //        this.$Modal.confirm({
            //            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
            //                this.$store.commit('fontorder/getPdf', {
            //                    pdfGuid: data.pdfGuid,
            //                    userId: data.userId,
            //                    orderNumber: data.orderNumber
            //                });
            //            }
            //        });
            //    }
            //    else {
            //        this.$store.commit('fontorder/getPdf', {
            //            pdfGuid: data.pdfGuid,
            //            userId: data.userId,
            //            orderNumber: data.orderNumber
            //        });
            //    }
            //}
            if (name == "修改本土包裹") {
                this.$store.state.backmainlandorder.packageName = data.packageName;
                this.$store.state.backmainlandorder.id = data.id;
                this.$store.state.backmainlandorder.cargoCategory = data.cargoCategory;
                this.editShipmentModalShow = true;
            }
            else if (name == "复制订单编号") {
                this.copyInfo(data.orderNumber);
            }
            //else if (name == "称重") {
            //    this.$store.state.backmainlandorder.id = data.id;
            //    this.weightShow = true;
            //}
            else if (name == "复制快递单号") {
                var stringList: Array<string> = [];
                data.logistics.forEach(function (element) {
                    stringList.push(element.shipment);
                });
                this.copyInfo(stringList.join("/"));
            }
            else if (name == '标记为异常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = -1;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                this.$store.state.backmainlandorder.updateOrdeData = updateData;

                this.updateOderStatuShow = true;
            } else if (name == '标记为正常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = 0;
                updateData.orderNumber = data.orderNumber;
                updateData.reMark = data.warehouseNote;
                updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                this.$store.state.backmainlandorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            } else if (name == '撤销订单') {
                await this.$store.dispatch({
                    type: 'backmainlandorder/cancelOrder',
                    data: { id: data.id }
                });
                this.getpage();
            }
        }

        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }



        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            },
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            },
            {
                title: '订单站点',
                width: 90,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }

            },
            {
                title: '物流方式',
                key: 'shippingMethods',
                width: 150,
            },
            {
                title: '用户编号',
                key: 'userCode',
                width: 90,
            },
            {
                title: '快递信息',
                key: 'logistics',
                width: 450,
              //  fixed: 'left',
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map((item, index) => {
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var color = PackageStatus.color;

                        if (item.isReject || item.isReturn || packagestus == "已撤销") {
                            color = "#ff0000";
                        }

                        // 构建显示内容
                        var shipment = item.shipment || '';
                        var shelfNumber = item.shelfNumber ? '-' + item.shelfNumber : '';
                        var count = item.orderCount > 1 ? "【" + item.orderCount + "】" : '';

                        // 尺寸重量信息 - 合并到一行
                        var sizeInfo = '';
                        if (item.long && item.wide && item.high) {
                            sizeInfo = `${item.long}*${item.wide}*${item.high}cm`;
                        }

                        var weightInfo = item.weight ? `${item.weight}g` : '';
                        var bulkyInfo = item.bulkyByClient ? `体积:${item.bulkyByClient}g` : '';
                        var finalWeight = item.heavyWeight ? `实重:${item.heavyWeight}g` : '';
                        var freightInfo = item.freightCost ? `积分:${item.freightCost}` : '';

                        // 是否付费
                        var deductionText = item.isDeduction !== undefined ? (item.isDeduction ? '已付费' : '未付费') : '';

                        // 第二行合并所有信息
                        var secondLineInfo = [
                            sizeInfo,
                            weightInfo,
                            bulkyInfo,
                            finalWeight,
                            freightInfo,
                            deductionText
                        ].filter(function (info) { return info && info !== ''; }).join(' | ');

                        return h('li', {
                            style: {
                                border: '1px solid #e8eaec',
                                margin: '5px 0',
                                padding: '8px',
                                borderRadius: '4px',
                                backgroundColor: color ? '#f8f8f9' : 'transparent'
                            }
                        }, [
                            h('div', {
                                style: {
                                    borderLeft: color ? `5px solid ${color}` : 'none',
                                    paddingLeft: '5px'
                                }
                            }, [
                                // 第一行：快递单号和基础信息
                                h('div', {
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        marginBottom: '5px'
                                    }
                                }, [
                                    h('span', {
                                        style: { fontWeight: 'bold', marginRight: '5px' }
                                    }, '快递单号：'),
                                    h('span', {
                                        style: { color: '#1890ff', marginRight: '10px' }
                                    }, shipment),

                                    deductionText ? h('span', {
                                        style: {
                                            marginRight: '10px',
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            background: item.isDeduction ? '#52c41a' : '#ff4d4f',
                                            color: 'white'
                                        }
                                    }, deductionText) : null,

                                    count ? h('span', {
                                        style: { color: '#f5222d', marginRight: '10px' }
                                    }, count) : null,

                                    shelfNumber ? h('span', {
                                        style: {
                                            background: '#f5f5f5',
                                            padding: '2px 6px',
                                            borderRadius: '4px'
                                        }
                                    }, shelfNumber) : null,

                                    item.weightImageUploadGuid ? h('img', {
                                        style: {
                                            width: '30px',
                                            height: '30px',
                                            marginLeft: '5px',
                                            verticalAlign: 'middle',
                                            borderRadius: '4px',
                                            border: '1px solid #d9d9d9',
                                            cursor: 'pointer'
                                        },
                                        attrs: {
                                            src: this.getImageUrl(item.weightImageUploadGuid),
                                            preview: params.row.id + '-' + index,
                                            "preview-text": item.shipment + '称重图片'
                                        }
                                    }) : null
                                ]),

                                // 第二行：尺寸重量等信息（合并为一行）
                                secondLineInfo ? h('div', {
                                    style: {
                                        fontSize: '12px',
                                        color: '#666',
                                        marginTop: '3px'
                                    }
                                }, secondLineInfo) : null,

                                // 称重时间单独一行（如果需要显示）
                                item.weighingTime ? h('div', {
                                    style: {
                                        marginTop: '3px',
                                        fontSize: '12px',
                                        color: '#999'
                                    }
                                }, '称重时间：' + DateUtils.formatLongDate(new Date(item.weighingTime))) : null
                            ])
                        ]);
                    }));
                }
            },
      
            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), h('h2', { style: { color: "red", display: "inline-block" } }, item.count)]);
                    }));
                }
            }, {
                title: '备注',
                width: 150,
                key: 'reMark',
            }
            ,
            {
                title: '产品订单状态',
                width: 110,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: 'red' } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },
            {
                title: '采购订单编号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        return h('li', {
                            domProps: {
                                innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                            }
                        });
                    }));
                }
            }, {
                title: '货物类别',
                width: 90,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },
            {
                title: '运单号',
                key: 'tradeNo',
                width: 150,
            }, {
                title: '包裹状态',
                width: 120,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name,
                    )
                }
            },
            //{
            //    title: '包裹基本信息',
            //    key: '',
            //    width: 250,
            //    render: (h: any, params: any) => {
            //        return h('span', "长：" + (params.row.long == null ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == null ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == null ? "" : params.row.high)+"cm")
            //    }
            //}, 
            //{
            //    title: '重量重【g】',
            //    key: 'heavyWeight',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.heavyWeight == null ? "" : params.row.heavyWeight)
            //    }
            //},
            //{
            //    title: '体积重【g】',
            //    key: 'bulkyByXGD',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.bulkyByXGD == null ? "" : params.row.bulkyByXGD)
            //    }
            //},
            //{
            //    title: '实际计算重量【g】',
            //    key: 'weightByXGD',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.weightByXGD == null ? "" : params.row.weightByXGD)
            //    }
            //},
            {
                title: '运费',
                key: 'freightCost',
                //className: this.Dispaly,
                width: 150,
                render: (h: any, params: any) => {
                    //var _this = this;
                    //if (params.row.packageStatus == 2) {
                    //    _this.Dispaly = "demo-table-info-column";
                    //}
                    return h('span', params.row.freightCost == 0 ? "" : params.row.freightCost)
                }
            }, {
                title: '是否支付',
                key: 'isPay',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.isPay ? this.L('是') : this.L('否'))
                }
            },
            {
                title: '称重上传图片',
                key: 'weightImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.weightImageUploadGuid) {
                        var data = { imageGuid: params.row.weightImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id+"*",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            }
            , {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id+"//",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '错误信息',
                key: 'mistakeinfomation',
                width: 150,
            },
            {
                title: '打包人',
                key: 'packedUserName',
                width: 90,
            },{
                title: '创建时间',
                key: 'createTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            }, {
                title: '本土包裹名称',
                key: 'packageName',
                width: 200,
                render: (h: any, params: any) => {
                    // 为每一行创建独立的防抖函数
                    let debounceTimer: any = null;
                    const rowId = params.row.id;

                    return h('span', {
                        style: {
                            color: '#1890ff',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        },
                        on: {
                            dblclick: async () => {
                                const orderId = params.row.id;
                                const trackingNumber = params.row.packageName;

                                if (!trackingNumber) {
                                    this.$Message.warning('没有可查询的物流单号');
                                    return;
                                }
                                this.debouncedQueryTrack(orderId, trackingNumber);
                            }
                        }
                    }, params.row.packageName);
                }
            }, {
                title: '货运单号',
                key: 'waybillNumber',
                width: 120,
            },{
                title: '仓库名称',
                key: 'warehouseName',
                width: 150,
            },{
                title: '接收时间',
                key: 'receivedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.receivedTime ? DateUtils.formatLongDate(new Date(params.row.receivedTime)) : '');
                }
            }, {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            }, {
                title: '打包时间',
                key: 'packedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.packedTime ? DateUtils.formatLongDate(new Date(params.row.packedTime)) : '');
                }
            }, {
                title: '称重时间',
                key: 'weighingTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.weighingTime ? DateUtils.formatLongDate(new Date(params.row.weighingTime)) : '');
                }
            }, {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                    var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    if (params.row.packageStatus==4) {
                        menu.push("修改本土包裹");
                    }
                 
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                        menu.push("标记为异常");
                    }
                    if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                        menu.push("标记为正常");
                    }
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 4 && params.row.packageStatus != 5) {
                        menu.push("撤销订单");
                    }
                    //if (params.row.orderStatus == 0 && params.row.packageStatus ==2) {
                    //    menu.push("称重");
                    //}
               
                    menu.push("复制订单编号");
                    if (params.row.logistics && params.row.logistics.length > 0) {
                        menu.push("复制快递单号");
                    }
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),

                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )],
                        ),
                         h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var _this = this;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                                _this.printPdf(data);
                                            }
                                        });
                                    }
                                    else {
                                        _this.printPdf(data);
                                    }
                                }
                            }
                        }, "打印PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
                                                this.$store.commit('fontorder/getPdf', {
                                                    pdfGuid: data.pdfGuid,
                                                    userId: data.userId,
                                                    orderNumber: data.orderNumber
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        this.$store.commit('fontorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            userId: data.userId,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),
                        h('Button', {
                            props: {
                                type: 'success',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                            },
                            on: {
                                click: () => {
                                    this.singleWeighing(data);
                                }
                            }

                        }, "称重"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                                display: (packageStatus == "已称重" && orderStatus == "正常") ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.Newpacked(data);
                              
                                }
                            }

                        }, "打包")
                    ]);
                }
            }]



        // 在类中添加防抖存储
        debounceTimers: Map<number, any> = new Map();

        // 防抖查询方法 - 无loading版本
        debouncedQueryTrack(orderId: number, trackingNumber: string) {
            // 清除该订单的现有定时器
            if (this.debounceTimers.has(orderId)) {
                clearTimeout(this.debounceTimers.get(orderId));
            }

            // 设置新的定时器
            const timer = setTimeout(async () => {
                // 调用轨迹查询接口
                const trackList = await this.$store.dispatch('backmainlandorder/getLogisticsTrack', {
                    orderId: orderId,
                    number: trackingNumber
                });

                if (trackList && trackList.length > 0) {
                    // 格式化轨迹信息，只显示时间和步骤
                    const trackHtml = this.formatTrackInfo(trackList);

                    this.$Modal.info({
                        title: '物流轨迹 - ' + trackingNumber,
                        width: 600,
                        content: trackHtml,
                        okText: '关闭'
                    });
                } else {
                    this.$Modal.info({
                        title: '物流轨迹',
                        content: '暂无轨迹信息'
                    });
                }

                // 清除定时器记录
                this.debounceTimers.delete(orderId);
            }, 300);

            // 存储定时器
            this.debounceTimers.set(orderId, timer);
        }

        /**
 * 格式化轨迹信息，只显示时间和步骤
 */
        formatTrackInfo(trackList: any[]): string {
            if (!trackList || trackList.length === 0) {
                return '<p>暂无轨迹信息</p>';
            }

            // 按时间倒序排序（最新的在前面）
            const sortedList = [...trackList].sort((a, b) => {
                const timeA = a.statusTime ? new Date(a.statusTime).getTime() : 0;
                const timeB = b.statusTime ? new Date(b.statusTime).getTime() : 0;
                return timeB - timeA;
            });

            let html = '<div style="max-height: 400px; overflow-y: auto;">';
            html += '<table style="width: 100%; border-collapse: collapse;">';
            html += '<thead><tr style="background-color: #f5f7f9;">';
            html += '<th style="padding: 10px; border: 1px solid #e8eaec; text-align: left;">时间</th>';
            html += '<th style="padding: 10px; border: 1px solid #e8eaec; text-align: left;">物流状态</th>';
            html += '</tr></thead>';
            html += '<tbody>';

            sortedList.forEach((item, index) => {
                const statusTime = item.statusTime ? this.formatDateTime(item.statusTime) : '';
                const statusName = item.statusName || '未知状态';
                const backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafafa';

                html += `<tr style="background-color: ${backgroundColor};">`;
                html += `<td style="padding: 8px; border: 1px solid #e8eaec;">${statusTime}</td>`;
                html += `<td style="padding: 8px; border: 1px solid #e8eaec;">${statusName}</td>`;
                html += '</tr>';
            });

            html += '</tbody></table>';
            html += '</div>';

            return html;
        }

        /**
         * 格式化日期时间
         */
        formatDateTime(dateStr: string): string {
            if (!dateStr) return '';

            try {
                const date = new Date(dateStr);
                if (isNaN(date.getTime())) return dateStr;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch {
                return dateStr;
            }
        }

        async created() {
       
            var a = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
            if (a == false) {
                this.columns.splice(14, 1);
            }
            this.getpage();
        }
    }
